import { FunctionComponent } from "react"

type FilterIconProps = {
  fillColor?: string // Optional fill color prop
}

export const SortIconPlaceholder: FunctionComponent = () => {
  return (
    <span className="w-4 h-4" id="sortIconPlaceholderContainer">
      <svg
        id="sortIconPlaceholder"
        className="w-4 h-4 text-gray-300 invisible"
        fill="currentColor"
        viewBox="0 0 20 20">
        <path d="M10 14l-5-5h10l-5 5z" />
      </svg>
    </span>
  )
}

export const FilterIcon: FunctionComponent<FilterIconProps> = ({
  fillColor = "currentColor", // Default to currentColor if not provided
}) => {
  const stroke = fillColor === "black" ? "none" : "black"

  return (
    <span className="ml-1 w-4 h-4 flex items-center">
      <svg className="w-4 h-4" fill={fillColor} viewBox="0 0 24 24">
        <path
          stroke={stroke}
          strokeLinecap="round"
          strokeWidth="2"
          d="M18.796 4H5.204a1 1 0 0 0-.753 1.659l5.302 6.058a1 1 0 0 1 .247.659v4.874a.5.5 0 0 0 .2.4l3 2.25a.5.5 0 0 0 .8-.4v-7.124a1 1 0 0 1 .247-.659l5.302-6.059c.566-.646.106-1.658-.753-1.658Z"
        />
      </svg>
    </span>
  )
}
